<template>
  <div class="screenshot">
    <img ref="imageRef" :src="props.src" :alt="props.alt" @click="openModal" @load="onImageLoad" tabindex="0"/>
    <div class="screenshot-mark">
      <Icon name="general.magnifier" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { usePhotoSwipe } from './../../../modules/viewer/composables/usePhotoSwipe';
import { Icon } from '@/storybook';

const props = defineProps<{
  src: string;
  expandedSrc?: string;
  alt?: string;
}>();

const imageRef = ref<HTMLImageElement | null>(null);

// Use expandedSrc for PhotoSwipe if provided, otherwise fallback to src
const fullSizeImageSrc = props.expandedSrc || props.src;
const { init, open } = usePhotoSwipe(fullSizeImageSrc);

const onImageLoad = () => {
  // If we have an expandedSrc, we need to get dimensions from that image instead
  if (props.expandedSrc && props.expandedSrc !== props.src) {
    const tempImg = new Image();
    tempImg.onload = () => {
      init(tempImg.naturalWidth, tempImg.naturalHeight);
    };
    tempImg.src = props.expandedSrc;
  } else {
    // Fallback to thumbnail dimensions if no expandedSrc or same as src
    const width = imageRef.value ? imageRef.value.naturalWidth : undefined;
    const height = imageRef.value ? imageRef.value.naturalHeight : undefined;
    init(width, height);
  }
};

const openModal = () => {
  open();
};
</script>

<style scoped>
.screenshot {
  @apply relative w-fit max-w-[800px] bg-slate-100 dark:bg-zinc-800 border border-slate-200 dark:border-zinc-700 p-[0.625rem] rounded-10;
}

.screenshot-mark {
  @apply hidden absolute top-8 right-8 bg-slate-200/90 dark:bg-zinc-700/90 text-slate-600 dark:text-zinc-300 p-[0.625rem] rounded-lg;
}

.screenshot:hover .screenshot-mark {
  @apply block;
}

.screenshot img {
  @apply cursor-pointer rounded-4 mb-0;
}
</style>